import UnitPrice from "@/orders/domain/models/unit-price";
import PurchaseOrder from "@/orders/domain/models/purchase-order";
import PurchaseOrderItem from "@/orders/domain/models/purchase-order-item";
import PurchaseOrderItems from "@/orders/domain/models/purchase-order-items";

export function toPurchaseOrder(data: any): PurchaseOrder {
  return new PurchaseOrder(
    data.id,
    data.purchaseNumber,
    data.projectId,
    data.projectName,
    data.staffName,
    data.title,
    data.mention,
    data.status,
    data.statusName,
    data.estimateId,
    data.estimateNumber,
    data.estimateTaxRate,
    data.estimateLoss,
    data.estimateDiscount,
    data.totalLossOfEstimateRow,
    data.vendorId,
    data.vendorName,
    data.taxRate,
    toPurchaseOrderItems(data.items),
    Boolean(data.printsExcludeTax),
    data.issuedAt,
    data.dateOfIssue,
    data.deliveryDate
  );
}

export function toPurchaseOrderItems(data: any[]): PurchaseOrderItems {
  if (data.length > 0) {
    return new PurchaseOrderItems(...data.map(toPurchaseOrderItem));
  }
  return new PurchaseOrderItems();
}

export function toPurchaseOrderItem(data: any): PurchaseOrderItem {
  const items = toPurchaseOrderItems(data.items);

  return new PurchaseOrderItem(
    data.id,
    data.estimateItemId,
    data.unitName,
    data.unitType,
    new UnitPrice(data.unitPrice),
    new UnitPrice(data.unitLoss),
    data.amount,
    data.memo,
    items
  );
}
